import { AnimationVariants } from "@di-devs/base-components";
import { Card, type CardProps } from "antd";
import { motion } from "framer-motion";
import type { FC, ReactNode } from "react";
import { useAudienceContext } from "../providers/AudienceContext";

export interface AudienceMainProps {
	children?: ReactNode; // Optional - can render tab content or custom children
	className?: string;
	cardProps?: CardProps;
	// TODO: Deprecate for https://github.com/miraicSystem/monocentral/issues/105
	enableAnimation?: boolean;
}

const AudienceMain: FC<AudienceMainProps> = ({
	children,
	className = "",
	cardProps = {},
	enableAnimation = true,
}) => {
	const { activeTabIndex, tabs } = useAudienceContext();

	// Determine what content to render
	let contentToRender: ReactNode = children;

	// If no custom children provided, render active tab content
	if (
		!children &&
		tabs.length > 0 &&
		activeTabIndex >= 0 &&
		activeTabIndex < tabs.length
	) {
		contentToRender = tabs[activeTabIndex].content;
	}

	const content = (
		<Card
			bordered={false}
			className={`shadow-none ${className}`}
			{...cardProps}
		>
			{contentToRender}
		</Card>
	);

	if (!enableAnimation) {
		return content;
	}

	return (
		<motion.div
			variants={AnimationVariants.StaggerContainer}
			initial="hidden"
			animate="show"
			exit="exit"
			className="audience-main"
		>
			<motion.div variants={AnimationVariants.StaggerItem}>
				{content}
			</motion.div>
		</motion.div>
	);
};

export default AudienceMain;
